import { render, staticRenderFns } from "./amendInventory.vue?vue&type=template&id=f6956760"
import script from "./amendInventory.vue?vue&type=script&lang=js"
export * from "./amendInventory.vue?vue&type=script&lang=js"
import style0 from "./amendInventory.vue?vue&type=style&index=0&id=f6956760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports